import { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "./ui/button";
import { useI18n } from "../lib/i18n";
import { API } from "../App";
import { Shield, X } from "lucide-react";
import { Link } from "react-router-dom";

const ConsentBanner = ({ user }) => {
  const { locale, t } = useI18n();
  const [visible, setVisible] = useState(false);
  const isFr = locale === "fr";

  useEffect(() => {
    if (!user) return;
    const checkConsent = async () => {
      try {
        const res = await axios.get(`${API}/consent/me`);
        if (!res.data?.privacy_policy) {
          setVisible(true);
        }
      } catch {
        setVisible(true);
      }
    };
    checkConsent();
  }, [user]);

  const handleAccept = async () => {
    try {
      await axios.post(`${API}/consent/accept`, {
        privacy_policy: true,
        data_processing: true,
        email_notifications: true,
      });
      setVisible(false);
    } catch (err) {
      console.error("Consent error:", err);
    }
  };

  if (!visible || !user) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 p-4"
      data-testid="consent-banner"
    >
      <div className="max-w-3xl mx-auto bg-card border shadow-xl rounded-xl p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Shield className="w-8 h-8 text-primary flex-shrink-0" />
        <div className="flex-1 text-sm">
          <p className="font-medium mb-1">
            {t("consent.dataProtection")}
          </p>
          <p className="text-muted-foreground">
            {t("consent.message")}
            {" "}
            <Link to="/privacy" className="text-primary underline">
              {isFr ? "En savoir plus" : "Learn more"}
            </Link>
          </p>
        </div>
        <div className="flex gap-2 flex-shrink-0">
          <Button size="sm" onClick={handleAccept} data-testid="accept-consent-btn">
            {isFr ? "J'accepte" : "I accept"}
          </Button>
          <Button size="sm" variant="ghost" onClick={() => setVisible(false)} data-testid="dismiss-consent-btn">
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
